import * as React from "react";
import { ResponsiveRadar } from "@nivo/radar";
import data from "../../assets/data/sampleradardata";


const LabelComponent = ({ id, anchor }) => {
  const labels = id.split("|");

  return (
    <g
      transform={`translate(${
        anchor === "end" ? -260 : anchor === "middle" ? -30 : 0
      }, -8)`}
    >
      <text cols="20" rows="3"
        style={{
          fill: "#18ee97",
          fontFamily: "Roboto Condensed",
          fontSize: "11px",
          // fontStyle: "italic",
          fontWeight: "normal"
        }}
      >
        {labels[0]}
      </text>
      <text
      writingMode="rl"
        y={20}
        style={{
          fill: "#f56f3f",
          fontFamily: "Roboto",
          fontSize: "11px",
          fontStyle: "italic",
          fontWeight: "normal"
        }}
      >
        {labels[1]}
      </text>
    </g>
  );
};

const customTooltip = val => {
  return (
    <svg viewBox="0 0 200 200">
      <text>`${val} as test`</text>
    </svg>
  );
};

export default class RadarGraph extends React.Component {
  state = {};

  constructor(props) {
    super(props);
  }

  render() {
    const { maxValue, realData, realKeys, useCustomLabel=true } = this.props;

    return (
      <div
        className="nivo-container"
        style={{ width: "100%", height: "600px" }}
      >
        <ResponsiveRadar
          data={realData || data}
          keys={realKeys || ["my_response", "child_1_name", "dad_name"]} // map from fetched data as the legend depends on it
          indexBy="question" // based on data
          maxValue={maxValue || 'auto'}
          margin={{ top: 70, right: 80, bottom: 40, left: 80 }}
          curve="linearClosed"
          borderWidth={2}
          borderColor={{ from: "color" }}
          gridLevels={5}
          gridShape="circular"
          gridLabel={useCustomLabel ? LabelComponent : undefined}
          gridLabelOffset={30}
          enableDots={true}
          dotSize={12}
          dotColor={{ from: "color" }}
          dotBorderWidth={2}
          dotBorderColor={{ from: "color" }}
          enableDotLabel={true}
          dotLabel="value"
          dotLabelYOffset={-12}
          colors={["#8e0666", "#18ee97", "#f56f3f", "#feb743", "#e7233d"]}
          fillOpacity={0.25}
          // blendMode="lighten"
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          isInteractive={false} // toggles tooltip on hover
          theme={{
            dots: {
              text: {
                fill: "#fff"
              }
            },
            // tooltip: {
            //   text: {fill:"#000"}
            // }
          }}
          tooltipFormat = {customTooltip}
          legends={[
            {
              anchor: "top-left",
              direction: "column",
              translateX: -50,
              translateY: -40,
              itemWidth: 80,
              itemHeight: 40,
              itemTextColor: "#fff",
              symbolSize: 12,
              symbolShape: "circle",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemTextColor: "#999"
                  }
                }
              ]
            }
          ]}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/DataViz/radarGraph.Component.js